var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("div", { staticClass: "flex justify-between" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("routerTitles.PaymentPlan")))])
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "" },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.showClosed,
                            callback: function($$v) {
                              _vm.showClosed = $$v
                            },
                            expression: "showClosed"
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("payment_plan.showClosed")) +
                              "\n\t\t\t\t\t\t"
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.$t(
                                  "payment_plan.periodFilterTooltip"
                                ),
                                placement: "top"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-info",
                                staticStyle: {
                                  "margin-left": "4px",
                                  cursor: "help",
                                  color: "#909399"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("span", [_vm._v(_vm._s(_vm.$t("period")))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: { size: "mini", disabled: !_vm.showClosed },
                          on: { change: _vm.handleDateFilterChange },
                          model: {
                            value: _vm.dateFilter,
                            callback: function($$v) {
                              _vm.dateFilter = $$v
                            },
                            expression: "dateFilter"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "payment_plan.dateFilters.past3Months"
                              ),
                              value: "past3Months"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "payment_plan.dateFilters.past6Months"
                              ),
                              value: "past6Months"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "payment_plan.dateFilters.past12Months"
                              ),
                              value: "past12Months"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "payment_plan.dateFilters.year2025"
                              ),
                              value: "2025"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "payment_plan.dateFilters.year2024"
                              ),
                              value: "2024"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "payment_plan.dateFilters.year2023"
                              ),
                              value: "2023"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "payment_plan.dateFilters.customRange"
                              ),
                              value: "custom"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("payment_plan.dateFilters.all"),
                              value: "all"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.dateFilter === "custom"
                    ? _c(
                        "el-form-item",
                        [
                          _c("el-date-picker", {
                            attrs: {
                              size: "mini",
                              type: "daterange",
                              "range-separator": "-",
                              "start-placeholder": _vm.$t("startDate"),
                              "end-placeholder": _vm.$t("endDate"),
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              disabled: !_vm.showClosed
                            },
                            model: {
                              value: _vm.customDateRange,
                              callback: function($$v) {
                                _vm.customDateRange = $$v
                              },
                              expression: "customDateRange"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            disabled: !_vm.filtersChanged
                          },
                          on: { click: _vm.handleApplyFilters }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("apply")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", disabled: !_vm.canReset },
                          on: { click: _vm.handleResetFilters }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("reset")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  staticClass: "mb-10",
                  attrs: { size: "mini", disabled: _vm.loading },
                  on: { command: _vm.handleExport }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "mini", disabled: _vm.loading } },
                    [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t("export")) + " "),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", { attrs: { command: "csv" } }, [
                        _vm._v(_vm._s(_vm.$t("payment_plan.exportCsv")))
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", { attrs: { command: "excel" } }, [
                        _vm._v(_vm._s(_vm.$t("payment_plan.exportExcel")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("rslt-ag-grid", {
            attrs: {
              "grid-key": "payment-plan-grid",
              "grid-class": "payment-plan-grid",
              "column-defs": _vm.columnDefs,
              "row-data": _vm.paymentPlans,
              loading: _vm.loading,
              "pagination-page-size": _vm.limit,
              "get-row-id": _vm.getRowId
            },
            on: { "grid-ready": _vm.onGridReady }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }